import React, { useContext, useState, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { CoreContext } from '../../context/index.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import { f as SEARCH } from '../../paths-ZKN3m62_.js';
import '../../payment-YC9H491Y.js';
import useAutoFocus from '../../hooks/useAutoFocus.js';
import '../../index-nNbKOeeS.js';
import 'notistack';
import { getProductLink } from '../../utils/product.js';
import '../../helpers-kA_hdoOI.js';
import 'lodash';
import useUserInteractionEvent from '../../hooks/useUserInteractionEvent.js';
import '../../utils/currency.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import { getValidationSchema, initialValues } from './form/index.js';
import { I as InputAutocomplete } from '../../InputAutocomplete-bqsRqwt5.js';
import { Q as QuickSearchGraphql } from '../../QuickSearch-ab76fizv.js';
import { u as usePublicLazyQuery } from '../../requestsCollection-_VRM28HJ.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import 'i18next';
import 'react-i18next';
import '../../index-SAqL6VZm.js';
import '../../product-_pRduMz7.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/logger.js';
import '../../utils/auth.js';
import '../../utils/cookies.js';
import '../../utils/isBot.js';
import '../../utils/dataRouteFormat.js';
import 'yup';
import '@hookform/resolvers/yup';
import '../../validation-AjMAVn7m.js';
import '../../index-2586sEvh.js';
import '../../hooks/useOutsideClick.js';
import '../../Skeleton-RKr5mJai.js';
import '../EmptyMessage/index.js';
import '../../InputAutocompleteOption-ZBLmHamR.js';
import '../../TextHighlighter-ZyVmLG-I.js';
import '../../graphqlRequestClient-3KYHZKVm.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/fetchPolicyLookup.js';

const QuickSearch = ({ onSubmitCallback }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { apolloConfig, data: { siteConfig: { search: { minCharacters = 3 } = {} } = {} }, } = useContext(CoreContext);
    const { manualUserClickHandler } = useUserInteractionEvent();
    const { locale, push } = useRouter();
    const [options, setOptions] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    const [search, { loading, error }] = usePublicLazyQuery(apolloConfig(), QuickSearchGraphql, 'QuickSearch');
    const goToSearchPage = (searchText) => {
        push(`/${locale}${SEARCH}?q=${searchText}`);
        if (typeof onSubmitCallback === 'function')
            onSubmitCallback();
    };
    const onSubmit = (values) => {
        goToSearchPage(encodeURIComponent(values.search));
    };
    const onSelect = (option) => {
        manualUserClickHandler('click_search_suggestion', {
            search_term: option.label,
            label: 'search',
        });
        if (typeof onSubmitCallback === 'function')
            onSubmitCallback();
        push(`/${locale}${option.value}`);
    };
    const onSearchDebounce = useCallback(debounce(async (value) => {
        setOptions([]); // reset options to clear dropdown list
        const data = await search({ variables: { search: value, locale } }).then(res => { var _a; return (_a = res.data) === null || _a === void 0 ? void 0 : _a.products; });
        const productsList = get(data, 'items', []);
        const formattedOptions = productsList.map(product => ({
            value: getProductLink(product.url_key, product.categories),
            label: product.name,
        }));
        setOptions(formattedOptions);
        setHasSearched(true);
    }, 1000), []);
    const onSearch = (value) => {
        onSearchDebounce(value);
    };
    const onReset = () => {
        setHasSearched(false);
    };
    const { handleSubmit, control, setValue, formState: { errors }, } = useForm({
        resolver: getValidationSchema(minCharacters),
        defaultValues: initialValues,
        mode: 'onSubmit',
    });
    const ref = useAutoFocus({ tag: 'input' });
    return (React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
        React.createElement("fieldset", null,
            React.createElement("legend", null,
                React.createElement("h1", { className: "title" }, tLabel('search'))),
            React.createElement("div", { ref: ref, className: "search-product" },
                React.createElement(InputAutocomplete, { charactersMinLength: minCharacters, name: "search", placeholder: tLabel('productSearch'), control: control, pending: loading || !hasSearched, options: options, errors: errors, setValue: setValue, onChangeCallback: onSearch, onSelectCallback: onSelect, onResetCallback: onReset, filled: true, inputMode: "search" }),
                React.createElement("button", { "data-testid": "search-button-submit", className: "btn-black search-button", type: "submit", "aria-label": "Search submit" }, tLabel('search'))),
            error && (React.createElement("div", { className: "error error-ui", role: "alert" }, error.toString())))));
};

export { QuickSearch as default };
//# sourceMappingURL=index.js.map
